"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Users, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MeetingAttendeesProps {
  attendees: string[];
  onRemove: (attendee: string) => void;
  isSubmitting: boolean;
}

export const MeetingAttendees: React.FC<MeetingAttendeesProps> = ({
  attendees,
  onRemove,
  isSubmitting,
}) => {
  if (attendees.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {attendees.map((attendee) => (
        <Badge
          key={attendee}
          variant="secondary"
          className="flex items-center gap-1 px-2 py-1"
        >
          <Users size={12} />
          <span>{attendee}</span>
          <button
            type="button"
            onClick={() => onRemove(attendee)}
            disabled={isSubmitting}
            className="ml-1 hover:text-red-600"
          >
            <X size={12} />
          </button>
        </Badge>
      ))}
    </div>
  );
};
